import AdminForm from 'components/organisms/AdminForm'

const Admin = () => {
  return <AdminForm />
}

export default Admin
